<script>
import MyTournee from './MyTournee/index.vue';
export default MyTournee;
</script>